import { Injectable, Injector, inject, runInInjectionContext } from '@angular/core';
import { collection, doc, getDoc } from 'firebase/firestore';
import { Observable, from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CartItem, firestoreDateParser } from '@pedix-workspace/utils';
import {
  WHATSAPP_BOT_CART_DRAFTS_COLLECTION,
  getWhatsappBotCartDraftConverter,
} from '@pedix-workspace/shared-models';
import { FIREBASE_FIRESTORE } from '@pedix-workspace/angular-firebase';

@Injectable({ providedIn: 'root' })
export class CartDraftService {
  private firestore = inject(FIREBASE_FIRESTORE);
  private injector = inject(Injector);

  getDraftCartItems(draftId: string, establishmentId: string): Observable<CartItem[] | null> {
    const docPromise = runInInjectionContext(this.injector, () =>
      getDoc(
        doc(
          collection(this.firestore, WHATSAPP_BOT_CART_DRAFTS_COLLECTION).withConverter(
            getWhatsappBotCartDraftConverter(),
          ),
          draftId,
        ),
      ),
    );

    return from(docPromise).pipe(
      map(snapshot => {
        const draft = snapshot.exists() ? snapshot.data() : null;

        if (!draft || draft.establishmentId !== establishmentId) {
          return null;
        }
        if (firestoreDateParser(draft.ttl).getTime() < Date.now()) {
          return null;
        }

        return draft.details.cartItems ?? [];
      }),
      catchError((error: unknown) => {
        console.error(error);

        return of(null);
      }),
    );
  }
}
